<template>
    <div class="message-main">
        <div class="end-box" v-if="dialogEnd">
            <div class="end-main animated zoomIn">
                <div class="end-title-box">
                    <div class="end-title-text">提示</div>
                </div>
                <div class="end-center">
                    <div class="end-info-box">代码已提交给老师，即将跳转到下一节课程。</div>
                    <div class="end-info-time">{{timeNum}}秒后将进入下一节</div>
                </div>
                <div @click="nowToNext()" class="end-button-box">
                    <div>立即进入下一节</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'MessageBox',
        props: {
            dialogEnd: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                timeNum:5,
                timer:''
            }},
        created() {
        },
        mounted:function(){
        },
        methods: {
            // 定时器开启
            startTime(){
                let _this = this
                _this.timeNum = 5
                this.timer = setInterval(function () {
                    if(_this.timeNum > 0){
                        _this.timeNum = _this.timeNum-1
                    }else{
                        clearInterval(_this.timer);
                        _this.$emit('timeEnd')
                    }
                },1000);
            },
            // 立即进入下一节
            nowToNext(){
                clearInterval(this.timer);
                this.$emit('timeEnd')
            }

        }
    }
</script>

<style scoped>
    /*结束弹窗开始*/
    .end-box{
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0; right: 0; bottom: 0; left: 0;
        background: rgba(0,0,0,0.5);
        text-align: center;
        white-space: nowrap;
        z-index: 9999;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .end-main{
        width: 30rem;
        height: 20rem;
        border: 0.5rem solid #4292f6;
        border-radius: 3rem;
        background-color: rgba(255, 255, 255, 0.9);
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
    }
    .end-title-box{
        width: 100%;
        text-align: center;
        height: 5rem;
        line-height: 5rem;
    }
    .end-title-text{
        font-size: 1.5rem;
        font-weight: bold;
    }
    .end-info-box{
        display: flex;
        justify-content: center;
        align-items: center;
        line-height: 3rem;
        font-size: 1.2rem;
    }
    .end-button-box{
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 5rem;
    }
    .end-button-box div{
        background-color: #4292f6;
        line-height: 3rem;
        color: #ffffff;
        width: 12rem;
        border-radius: 1rem;
        font-size: 1.2rem;
    }
    .end-info-time{
        color: #ec2908;
        font-size: 1.1rem;
    }
    /*结束弹窗结束*/
</style>
